// src/components/Hero.js
import React from 'react';
import { Icons } from './Icons';

function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <span className="hero-badge">Продвинутый модератор</span>
            <h1>Atri Bot — <br />ваш идеальный <br />помощник в Telegram</h1>
            <p className="hero-description">
              Полноценная система модерации с автоматической защитой от спама, 
              рейдов и нарушителей. Умный бот, который работает за вас 24/7.
            </p>
            <div className="hero-buttons">
              <a href="https://t.me/AtriGuard_bot" className="btn-primary">
                <Icons.Telegram />
                Добавить бота
              </a>
              <a href="https://atri-bot.online" className="btn-secondary">
                <Icons.ExternalLink />
                Онлайн-панель
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Работает всегда</span>
              </div>
              <div className="stat">
                <span className="stat-number">∞</span>
                <span className="stat-label">Без ограничений</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Бесплатно</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-phone">
              <div className="phone-screen">
                <div className="phone-header">
                  <span>Atri Bot</span>
                  <span className="online-dot"></span>
                </div>
                <div className="phone-messages">
                  <div className="message received">
                    <span>Добро пожаловать в чат!</span>
                  </div>
                  <div className="message sent">
                    <span>/commands</span>
                  </div>
                  <div className="message received">
                    <span>Вот что я умею...</span>
                  </div>
                  <div className="message sent">
                    <span>/onlinepanel</span>
                  </div>
                  <div className="message received highlight">
                    <span>Код отправлен в ЛС</span>
                  </div>
                </div>
                <div className="phone-footer">
                  <span>Сообщение...</span>
                  <button>Отправить</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;